import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
import {
    makeSelectTimesheetValue
    // @ts-ignore
} from 'services/timesheet/selectors';

interface ConnectedProps {
    personLastName?: string;
}

type Props = ConnectedProps;

export class SelectedTimesheetPersonLastNameValue extends React.PureComponent<
    Props
> {
    render(): string | null {
        const { personLastName } = this.props;
        if (!personLastName) {
            return null;
        }
        return personLastName;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    personLastName: makeSelectTimesheetValue('personLastName')
});

export default connect(mapStateToProps)(SelectedTimesheetPersonLastNameValue);
